import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import CoursePage from "@/pages/CoursePage";
import CourseSuccess from "@/pages/CourseSuccess";
import CourseLearn from "@/pages/CourseLearn";
import CourseTutor from "@/pages/CourseTutor";
import KidsCorner from "@/pages/KidsCorner";
import KidsVocab from "@/pages/KidsVocab";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import ResourcesPage from "@/pages/ResourcesPage";
import { LumiProvider } from "@/components/LumiCharacter";

function App() {
  return (
    <div className="App font-nunito">
      <BrowserRouter>
        <LumiProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/course" element={<CoursePage />} />
            <Route path="/course/success" element={<CourseSuccess />} />
            <Route path="/course/learn" element={<CourseLearn />} />
            <Route path="/course/tutor" element={<CourseTutor />} />
            <Route path="/kids-corner" element={<KidsCorner />} />
            <Route path="/kids-vocab" element={<KidsVocab />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            {["/privacy", "/childrens-privacy", "/terms", "/refund-policy", "/contact"].map((p) => (
              <Route key={p} path={p} element={<LegalPage />} />
            ))}
          </Routes>
        </LumiProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
